import { Box, Button, CircularProgress, FormControl, Grid, IconButton, Paper, Tooltip, Typography } from "@mui/material";
import { useSnackbar } from "notistack";

import { Link, useNavigate } from "react-router-dom";


import { useEffect, useState } from "react";

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { format } from 'date-fns';
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { Acompanhamento, ISacompanhamento } from "../../../types/processo/Acompanhamento";
import { ISprocesso } from "../../../types/processo/Processo";

import configUrls from "../../../config/configUrls";
import { GridDeleteIcon } from "@mui/x-data-grid";
import ConfirmDialogList from "../../../components/ConfirmDialogList";
import { useGetProcessoCienciasQuery } from "../processoApiSlice";
import { ProcessoDarCienciaList } from "../../../types/processo/ProcessoDarCienciaList";



export const ProcessoDarCienciaListForm = () => {

    const { enqueueSnackbar, closeSnackbar } = useSnackbar()
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate(); // Hook para navegação


    const [ciencias, setCiencias] = useState<ProcessoDarCienciaList[]>([]);


    const { processoSelecionado } = useSelector((state: RootState) => state.processoSelecionado);
    useEffect(() => {
        if (!processoSelecionado) {
            alert("Nenhum processo selecionado");
            window.location.href = configUrls.PROCESSO_LIST_RT
        }
    }, [processoSelecionado]);


    const { data, isFetching, error } = useGetProcessoCienciasQuery(processoSelecionado?.id ?? "");

    useEffect(() => {
        if (data) {
            setCiencias(data);
        }
        if (error) {
            enqueueSnackbar("Ciências não encontradas!", { variant: "error" });
        } else if (isFetching) {
            enqueueSnackbar("Buscando registros...", { variant: "info" });
        }
    }, [data, error, isFetching, enqueueSnackbar]);


    if (isFetching) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
                <CircularProgress />
            </Box>
        );
    }
    const headerGerados = (
        <Typography variant="body2" color="textSecondary">
            Ciência(s) encontrada(s): {ciencias.length}
        </Typography>
    );


    const renderData = (rowData: ProcessoDarCienciaList) => {
        const dataCriacao = rowData.dataHora ? format(rowData.dataHora, 'dd/MM/yyyy HH:mm:ss') : "Data não disponível";
        return <Typography color="secondary" variant="body2">{dataCriacao}</Typography>;
    };

    const renderUsuario = (rowData: ProcessoDarCienciaList) => (
        <Typography color="secondary" variant="body2">{rowData.usuario?.nome || "Usuário não disponível"}</Typography>
    );

    return (
        <>

            <Paper sx={{ width: "100%", height: "100vh", padding: "12px" }}>
                <Grid container padding={2}>
                    <Grid item xs={12}>
                        <FormControl fullWidth>


                            <Box display="flex" justifyContent="space-between" mb={2}>

                                <Box display="flex">
                                    <Typography color="secondary" variant="h6" gutterBottom>
                                        Ciências para o processo: {processoSelecionado?.numeroProcesso}
                                    </Typography>
                                </Box>
                                <Box display="flex" justifyContent="flex-end">
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => navigate(-1)}
                                    >
                                        Voltar
                                    </Button>
                                </Box>
                            </Box>




                        </FormControl>
                    </Grid>
                </Grid>

                <DataTable
                    value={ciencias}
                    paginator
                    rows={25}
                    showGridlines={true}
                    size="small"
                    columnResizeMode="expand"
                    resizableColumns
                    dataKey="id"
                    header={headerGerados}
                    className="custom-datatable"
                >

                    <Column header="Data" body={renderData} sortable style={{ width: '30%' }} />
                    <Column header="Usuário" body={renderUsuario} sortable style={{ width: '70%' }} />


                </DataTable>


            </Paper>










        </>







    );










};
